<template>

	<v-layout row wrap v-if="warning !== ''" style="color: #ff153c; padding-bottom: 1px">
		<v-flex d-flex xs12>
			<v-card color="yellow">
				<v-card-text>
					<v-icon>warning</v-icon>
					<strong>
						<b>
							{{warning}}
						</b>
					</strong>
				</v-card-text>
			</v-card>
		</v-flex>
	</v-layout>

</template>

<script>
	export default {
		name: "egrantyValidationWarning",

		props: {
			warning: String
		},
	};
</script>

<style scoped>

</style>